import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Flex, IDialogModal, inDialogModal } from "@/eworkitComponents";
import { CloseButton } from "@/views/components/CloseButton";
import { StyledModal } from "@/views/components/Modal";
import { ProfileType, ProfileTypePicker } from "@/views/components/ProfileTypePicker";

interface IProfileTypePickerDialogProps extends IDialogModal {
  onProfileSelect: (profileType: ProfileType) => void;
}

const ProfileTypePickerDialog: FC<IProfileTypePickerDialogProps> = ({ onProfileSelect, onClose }) => {
  const { t } = useTranslation("session");
  const baseClass = "context-picker-dialog";

  return (
    <StyledModal className={baseClass}>
      <Flex direction="column" margin={["xl"]} innerMargin="lg">
        <Flex justify="space-between">
          <Header size="md" color="black" weight="bold">
            {t("ONBOARDING.PROFILE_TYPE_SELECT.MODAL_HEADER")}
          </Header>
          <CloseButton onClick={onClose} testName="close" />
        </Flex>

        <ProfileTypePicker onProfileSelect={onProfileSelect} />
      </Flex>
    </StyledModal>
  );
};

const ProfileTypePickerDialogComponent = inDialogModal(ProfileTypePickerDialog);

interface IContextPickerDialogModalProps extends Omit<IProfileTypePickerDialogProps, "onSizeChange"> {}

export const ProfileTypePickerDialogModal: FC<IContextPickerDialogModalProps> = props => {
  return <ProfileTypePickerDialogComponent size="md" {...props} />;
};
